import { getFlyerCustomLabel, getSectionFromTableOfContentsByPage } from 'utils';
import { getPromoBaseCode } from 'utils/flyerVersion';

const PRECISION_IN_MS = 500;

export function formatDate(timestamp) {
  const date = new Date(timestamp);

  const roundedTime = Math.round(date.getMilliseconds() / PRECISION_IN_MS) * PRECISION_IN_MS;
  date.setMilliseconds(roundedTime);

  return date.toISOString();
}

export const eventFields = {
  gib: {
    getProductCode: (flyerGib) => ({
      product_code: flyerGib?.settings?.customer_product_id || '',
    }),
  },
  tag: {
    getProductName: (tag) => ({
      product_name: tag?.title || '',
    }),
    getFullPrice: (tag) => ({
      full_price: tag?.initialPrice || '',
    }),
    getDiscountedPrice: (tag) => ({
      discounted_price: tag?.price || '',
    }),
    getProductPosition: (tagId, productGibs, flyerGibsMap = {}) => {
      const gib = flyerGibsMap[tagId];
      const positionTagId = gib?.type === 'crop_child' && gib?.parent_id ? gib.parent_id : tagId;
      const index = productGibs?.findIndex((productGib) => productGib.id === positionTagId) ?? -1;

      return {
        product_position: index >= 0 ? `${index}` : '',
      };
    },
  },
  flyer: {
    // The NEXT copy of a flyer gets `_next` appended to its promo_code in superadmin;
    // retailers must only ever see the label they originally assigned.
    getCustomLabel: (flyer) => {
      const customLabel = getFlyerCustomLabel(flyer);
      return {
        custom_label: (getPromoBaseCode(customLabel) ?? customLabel) || '',
      };
    },
    stripNextFromCustomLabel: (payload) =>
      typeof payload?.custom_label === 'string'
        ? { ...payload, custom_label: getPromoBaseCode(payload.custom_label) ?? '' }
        : payload,
    getTotOffers: (productGibs) => ({
      products_count: `${productGibs?.length ?? 0}`,
    }),
    getTotalPages: (flyer) => ({
      total_pages: `${flyer?.lastPubblication?.settings?.number_of_pages ?? 0}`,
    }),
    getSection: (flyer, pageNumber) => {
      const section = getSectionFromTableOfContentsByPage(flyer, pageNumber);

      return {
        section: section?.label || '',
      };
    },
  },
  pageNumber: {
    getPageNumber: (flyerPage) => ({
      page_number: flyerPage || '',
    }),
  },
  date: {
    getOriginalTimestamp: () => ({
      original_timestamp: formatDate(Date.now()),
    }),
  },
};
